import coreAPIService from './coreAPIService';
import { CTW_NODE_API_ENDPOINT } from '../utils';

export interface ConversationRequest {
    clientUserId: string | number;
    userId: string;
}

const conversationService = {
    getEvents: (request: ConversationRequest) => coreAPIService.get<any>(
        CTW_NODE_API_ENDPOINT,
        'conversation/v1/events',
        { client_user_id: request.clientUserId, user_id: request.userId }
    ),

    getLogging: (request: ConversationRequest & { orgId: string }) => coreAPIService.get<any>(
        CTW_NODE_API_ENDPOINT,
        'conversation/v1/logging',
        { client_user_id: request.clientUserId, org_id: request.orgId, user_id: request.userId }
    ),

    getNudges: (request: { clientUserId: string | number; orgId: string; clientId: string; botId: string }) =>
        coreAPIService.get<any>(CTW_NODE_API_ENDPOINT, 'v1/nudges', {
            client_user_id: request.clientUserId,
            org_id: request.orgId,
            client_id: request.clientId,
            bot_id: request.botId,
        }),

    getHistory: (clientUserId: string | number, userId: string) => coreAPIService.get<any>(
        CTW_NODE_API_ENDPOINT,
        `conversation/v1/history/${encodeURIComponent(String(clientUserId))}`,
        { user_id: userId }
    ),
};

export default conversationService;
